import PersonData from './PersonData';
export default PersonData;
